const allowedCharacters = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";

export function randomCode(): string {
  return Array.from(
    { length: 6 },
    () =>
      allowedCharacters[Math.floor(Math.random() * allowedCharacters.length)],
  ).join("");
}
